/* dz-hydrate.js - DezLin self-hosted hydration for the 3 ex-PageFly clones that had
   JS-dependent widgets (customer-reviews carousel, learn-more accordion, giveaway countdown).
   Replaces the PageFly runtime with plain, dependency-free vanilla JS.

   - CAROUSEL: rebuilt as a fully DezLin-owned carousel (PageFly's cards are MOVED into our own
     track and PageFly's .glider is replaced), so it works even while PageFly is still installed
     and PageFly has nothing left to manage. No PageFly app/CDN/files are used.
   - ACCORDION + COUNTDOWN: gated on PageFly-absence (they render fine via PageFly until uninstall,
     then our code takes over). */
(function () {
  'use strict';

  function pageflyRuntimePresent() {
    return !!document.querySelector('script[src*="pagefly-page-builder"], link[href*="pagefly-page-builder"]');
  }

  // ---- read-more: truncate the review to a uniform length with a Read more/less toggle ----
  var REVIEW_LIMIT = 165;
  function setupReadMore(el) {
    el.classList.add('dz-review-body');
    if (el.__dzRM) return;
    var text = (el.textContent || '').trim();
    if (text.length <= REVIEW_LIMIT) return;
    el.__dzRM = true;
    var cut = text.slice(0, REVIEW_LIMIT).replace(/\s+\S*$/, '').trim() + '… ';
    el.textContent = '';
    var shortS = document.createElement('span'); shortS.textContent = cut;
    var longS = document.createElement('span'); longS.textContent = text + ' '; longS.style.display = 'none';
    var btn = document.createElement('a');
    btn.href = 'javascript:void(0)'; btn.className = 'dz-readmore'; btn.textContent = 'Read more';
    btn.addEventListener('click', function () {
      var showFull = longS.style.display === 'none';
      shortS.style.display = showFull ? 'none' : '';
      longS.style.display = showFull ? '' : 'none';
      btn.textContent = showFull ? 'Read less' : 'Read more';
    });
    el.appendChild(shortS); el.appendChild(longS); el.appendChild(btn);
  }

  // ---- rebuild the slider as a DezLin carousel: move the existing cards into our own track,
  //      replace PageFly's .glider, own the controls. PageFly is left with nothing to manage. ----
  function buildCarousel(slider) {
    if (slider.__dzBuilt) return;
    var glider = slider.querySelector('.glider');
    if (!glider) return;
    var cards = [].slice.call(glider.querySelectorAll('.glide-wrapper'));
    if (!cards.length) return;
    slider.__dzBuilt = true;

    var wrap = document.createElement('div'); wrap.className = 'dz-carousel';
    var track = document.createElement('div'); track.className = 'dz-track';
    cards.forEach(function (card) {
      var best = null, bl = 0;
      card.querySelectorAll('p,[data-pf-type="Text"],[data-pf-type="Paragraph"]').forEach(function (el) {
        var t = (el.textContent || '').trim();
        if (t.length > bl) { bl = t.length; best = el; }
      });
      if (best) setupReadMore(best);
      card.querySelectorAll('a[onclick*="myFunction"], a#myBtn').forEach(function (a) { a.style.display = 'none'; });
      card.classList.remove('glide-wrapper'); card.classList.add('dz-card');
      track.appendChild(card);
    });
    wrap.appendChild(track);

    function idxNearest() {
      var tl = track.getBoundingClientRect().left, best = 0, bd = 1e9, k = track.children;
      for (var i = 0; i < k.length; i++) { var d = Math.abs(k[i].getBoundingClientRect().left - tl); if (d < bd) { bd = d; best = i; } }
      return best;
    }
    function goTo(i) {
      i = Math.max(0, Math.min(i, track.children.length - 1));
      var delta = track.children[i].getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.scrollBy({ left: delta, behavior: 'smooth' });
    }
    function arrow(cls, label, glyph, delta) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'dz-arrow ' + cls; b.setAttribute('aria-label', label); b.textContent = glyph;
      b.addEventListener('click', function () { goTo(idxNearest() + delta); });
      return b;
    }
    wrap.appendChild(arrow('dz-prev', 'Previous review', '‹', -1));
    wrap.appendChild(arrow('dz-next', 'Next review', '›', 1));

    var dotsRow = document.createElement('div'); dotsRow.className = 'dz-dots-row';
    [].slice.call(track.children).forEach(function (c, i) {
      var d = document.createElement('button'); d.type = 'button'; d.className = 'dz-dot';
      d.setAttribute('aria-label', 'Go to review ' + (i + 1));
      d.addEventListener('click', function () { goTo(i); });
      dotsRow.appendChild(d);
    });
    wrap.appendChild(dotsRow);
    var dots = [].slice.call(dotsRow.children);
    var sync = function () { var ci = idxNearest(); dots.forEach(function (d, i) { d.classList.toggle('active', i === ci); }); };
    var raf; track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }); sync();

    glider.parentNode.replaceChild(wrap, glider); // remove PageFly's slider mechanism
  }

  function takeoverCarousels() {
    document.querySelectorAll('[data-pf-type="Slider2"], [data-dz-slider]').forEach(function (s) {
      s.removeAttribute('data-pf-type');
      s.setAttribute('data-dz-slider', '1');
      s.style.visibility = 'visible';
      s.style.height = 'auto';
      buildCarousel(s);
    });
  }

  function hydrate() {
    takeoverCarousels();

    if (pageflyRuntimePresent()) return; // accordion + countdown stay with PageFly until uninstall

    // ACCORDIONS - replicate PageFly's expand/collapse (learn-more "Live Reveal FAQ")
    document.querySelectorAll('[data-pf-type="Accordion.Header"]').forEach(function (btn) {
      if (btn.__dzWired) return;
      btn.__dzWired = true;
      btn.style.cursor = 'pointer';
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-header-id');
        var acc = btn.closest('[data-pf-type="Accordion"]');
        if (!acc) return;
        var panel = acc.querySelector('[data-pf-expandable][data-id="' + id + '"]');
        if (!panel) return;
        var isOpen = btn.getAttribute('data-active') === 'true';
        var multiple = acc.getAttribute('data-multiple') === 'true';
        if (!multiple && !isOpen) {
          acc.querySelectorAll('[data-pf-type="Accordion.Header"]').forEach(function (h) {
            if (h === btn) return;
            h.setAttribute('data-active', 'false');
            var p = acc.querySelector('[data-pf-expandable][data-id="' + h.getAttribute('data-header-id') + '"]');
            if (p) p.style.display = 'none';
            var oi = h.querySelector('.pfa');
            if (oi) { oi.classList.add('pfa-plus'); oi.classList.remove('pfa-minus'); }
          });
        }
        btn.setAttribute('data-active', isOpen ? 'false' : 'true');
        panel.style.display = isOpen ? 'none' : 'block';
        var icon = btn.querySelector('.pfa');
        if (icon) { icon.classList.toggle('pfa-plus', isOpen); icon.classList.toggle('pfa-minus', !isOpen); }
      });
    });

    // COUNTDOWN (giveaway) - self-hosted evergreen timer replacing PageFly's.
    document.querySelectorAll('[data-pf-type="CountDown"]').forEach(function (cd) {
      if (cd.__dzCd) return;
      var nums = cd.querySelectorAll('[data-pf-type="CountdownNumber"]');
      if (nums.length < 4) { cd.style.display = 'none'; return; }
      cd.__dzCd = true;
      cd.style.visibility = 'visible';
      var DUR = 20 * 60 * 1000;
      var KEY = 'dz_cd_' + (cd.getAttribute('data-header-id') || location.pathname);
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function target() {
        var t = parseInt(localStorage.getItem(KEY) || '0', 10), now = Date.now();
        if (!t || t <= now) { t = now + DUR; try { localStorage.setItem(KEY, String(t)); } catch (e) {} }
        return t;
      }
      function tick() {
        var s = Math.max(0, Math.floor((target() - Date.now()) / 1000));
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        nums[0].textContent = pad(d); nums[1].textContent = pad(h); nums[2].textContent = pad(m); nums[3].textContent = pad(s);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  function boot() { hydrate(); setTimeout(hydrate, 1200); setTimeout(hydrate, 3000); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
